export default "__VITE_PUBLIC_ASSET__8335d62f__"